export default __webpack_public_path__ + "static/media/Prophecy_3x2_Hk.661e349f.webp";